var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g, _path26, _path27, _path28, _path29, _path30, _g2, _path31, _g3, _path32, _g4, _path33, _g5, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLogoIturan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 42,
    viewBox: "0 0 79 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5226 20.5457C24.5226 21.3939 23.8357 22.0816 22.9881 22.0816C22.1405 22.0816 21.4536 21.3939 21.4536 20.5457C21.4536 19.6973 22.1405 19.0098 22.9881 19.0098C23.8357 19.0098 24.5226 19.6973 24.5226 20.5457Z",
    fill: "#96C93E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.459 4.99548C15.459 5.84384 14.7721 6.53135 13.9245 6.53135C13.077 6.53135 12.3901 5.84384 12.3901 4.99548C12.3901 4.14729 13.077 3.45978 13.9245 3.45978C14.7721 3.45978 15.459 4.14729 15.459 4.99548Z",
    fill: "#17A7E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1842 4.99548C20.1842 5.84384 19.4973 6.53135 18.6497 6.53135C17.8023 6.53135 17.1154 5.84384 17.1154 4.99548C17.1154 4.14729 17.8023 3.45978 18.6497 3.45978C19.4973 3.45978 20.1842 4.14729 20.1842 4.99548Z",
    fill: "#17A7E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6259 8.90437C15.6259 9.83757 14.87 10.5937 13.9382 10.5937C13.0058 10.5937 12.25 9.83757 12.25 8.90437C12.25 7.97117 13.0058 7.21521 13.9382 7.21521C14.87 7.21521 15.6259 7.97117 15.6259 8.90437Z",
    fill: "#17A7E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2854 8.90435C20.2854 9.78729 19.5704 10.5029 18.6883 10.5029C17.8061 10.5029 17.0909 9.78729 17.0909 8.90435C17.0909 8.0214 17.8061 7.30579 18.6883 7.30579C19.5704 7.30579 20.2854 8.0214 20.2854 8.90435Z",
    fill: "#17A7E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5875 12.6255C15.5875 13.5587 14.8317 14.315 13.8999 14.315C12.9673 14.315 12.2117 13.5587 12.2117 12.6255C12.2117 11.6923 12.9673 10.9363 13.8999 10.9363C14.8317 10.9363 15.5875 11.6923 15.5875 12.6255Z",
    fill: "#17A7E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.247 12.6255C20.247 13.5084 19.532 14.224 18.6498 14.224C17.7676 14.224 17.0525 13.5084 17.0525 12.6255C17.0525 11.7425 17.7676 11.0269 18.6498 11.0269C19.532 11.0269 20.247 11.7425 20.247 12.6255Z",
    fill: "#17A7E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5875 16.4204C15.5875 17.3536 14.8317 18.1095 13.8999 18.1095C12.9673 18.1095 12.2117 17.3536 12.2117 16.4204C12.2117 15.4872 12.9673 14.7312 13.8999 14.7312C14.8317 14.7312 15.5875 15.4872 15.5875 16.4204Z",
    fill: "#17A7E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.247 16.4204C20.247 17.3033 19.532 18.019 18.6498 18.019C17.7676 18.019 17.0525 17.3033 17.0525 16.4204C17.0525 15.5375 17.7676 14.8218 18.6498 14.8218C19.532 14.8218 20.247 15.5375 20.247 16.4204Z",
    fill: "#17A7E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5875 20.263C15.5875 21.1962 14.8317 21.9521 13.8999 21.9521C12.9673 21.9521 12.2117 21.1962 12.2117 20.263C12.2117 19.3298 12.9673 18.5738 13.8999 18.5738C14.8317 18.5738 15.5875 19.3298 15.5875 20.263Z",
    fill: "#17A7E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.247 20.263C20.247 21.1459 19.532 21.8615 18.6498 21.8615C17.7676 21.8615 17.0525 21.1459 17.0525 20.263C17.0525 19.38 17.7676 18.6644 18.6498 18.6644C19.532 18.6644 20.247 19.38 20.247 20.263Z",
    fill: "#17A7E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5875 24.0723C15.5875 25.0055 14.8317 25.7619 13.8999 25.7619C12.9673 25.7619 12.2117 25.0055 12.2117 24.0723C12.2117 23.1391 12.9673 22.3832 13.8999 22.3832C14.8317 22.3832 15.5875 23.1391 15.5875 24.0723Z",
    fill: "#17A7E0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.247 24.0723C20.247 24.9553 19.532 25.6709 18.6498 25.6709C17.7676 25.6709 17.0525 24.9553 17.0525 24.0723C17.0525 23.1894 17.7676 22.4738 18.6498 22.4738C19.532 22.4738 20.247 23.1894 20.247 24.0723Z",
    fill: "#17A7E0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5875 27.8817C15.5875 28.8149 14.8317 29.5709 13.8999 29.5709C12.9673 29.5709 12.2117 28.8149 12.2117 27.8817C12.2117 26.9485 12.9673 26.1926 13.8999 26.1926C14.8317 26.1926 15.5875 26.9485 15.5875 27.8817Z",
    fill: "#17A7E0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1842 27.8817C20.1842 28.7301 19.4973 29.4176 18.6497 29.4176C17.8023 29.4176 17.1154 28.7301 17.1154 27.8817C17.1154 27.0335 17.8023 26.346 18.6497 26.346C19.4973 26.346 20.1842 27.0335 20.1842 27.8817Z",
    fill: "#17A7E0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.247 12.6255C20.247 13.5084 19.532 14.224 18.6498 14.224C17.7676 14.224 17.0525 13.5084 17.0525 12.6255C17.0525 11.7425 17.7676 11.0269 18.6498 11.0269C19.532 11.0269 20.247 11.7425 20.247 12.6255Z",
    fill: "#17A7E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.247 16.4204C20.247 17.3033 19.532 18.019 18.6498 18.019C17.7676 18.019 17.0525 17.3033 17.0525 16.4204C17.0525 15.5375 17.7676 14.8218 18.6498 14.8218C19.532 14.8218 20.247 15.5375 20.247 16.4204Z",
    fill: "#17A7E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.247 20.263C20.247 21.1459 19.532 21.8615 18.6498 21.8615C17.7676 21.8615 17.0525 21.1459 17.0525 20.263C17.0525 19.38 17.7676 18.6644 18.6498 18.6644C19.532 18.6644 20.247 19.38 20.247 20.263Z",
    fill: "#17A7E0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1842 24.0723C20.1842 24.9206 19.4973 25.6081 18.6497 25.6081C17.8023 25.6081 17.1154 24.9206 17.1154 24.0723C17.1154 23.2241 17.8023 22.5366 18.6497 22.5366C19.4973 22.5366 20.1842 23.2241 20.1842 24.0723Z",
    fill: "#17A7E0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5853 8.90435C24.5853 9.78729 23.8703 10.5029 22.9881 10.5029C22.106 10.5029 21.391 9.78729 21.391 8.90435C21.391 8.0214 22.106 7.30579 22.9881 7.30579C23.8703 7.30579 24.5853 8.0214 24.5853 8.90435Z",
    fill: "#17A7E0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5853 12.6255C24.5853 13.5084 23.8703 14.224 22.9881 14.224C22.106 14.224 21.391 13.5084 21.391 12.6255C21.391 11.7425 22.106 11.0269 22.9881 11.0269C23.8703 11.0269 24.5853 11.7425 24.5853 12.6255Z",
    fill: "#17A7E0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5853 16.4204C24.5853 17.3033 23.8703 18.019 22.9881 18.019C22.106 18.019 21.391 17.3033 21.391 16.4204C21.391 15.5375 22.106 14.8218 22.9881 14.8218C23.8703 14.8218 24.5853 15.5375 24.5853 16.4204Z",
    fill: "#17A7E0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8163 4.99547C23.8163 5.45334 23.4455 5.82438 22.9881 5.82438C22.5306 5.82438 22.1595 5.45334 22.1595 4.99547C22.1595 4.53761 22.5306 4.16656 22.9881 4.16656C23.4455 4.16656 23.8163 4.53761 23.8163 4.99547Z",
    fill: "#17A7E0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4781 1.40179C19.4781 1.85965 19.1074 2.23069 18.6499 2.23069C18.1925 2.23069 17.8214 1.85965 17.8214 1.40179C17.8214 0.943922 18.1925 0.572876 18.6499 0.572876C19.1074 0.572876 19.4781 0.943922 19.4781 1.40179Z",
    fill: "#17A7E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_8233",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 2,
    height: 3
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0712 0.496094H14.7279V2.15382H13.0712V0.496094Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_8233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7279 1.32494C14.7279 1.78281 14.3572 2.15385 13.8997 2.15385C13.4422 2.15385 13.0712 1.78281 13.0712 1.32494C13.0712 0.867079 13.4422 0.496033 13.8997 0.496033C14.3572 0.496033 14.7279 0.867079 14.7279 1.32494Z",
    fill: "#17A7E0"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1457 1.44012C10.1457 1.89798 9.775 2.26902 9.31755 2.26902C8.86009 2.26902 8.48901 1.89798 8.48901 1.44012C8.48901 0.982252 8.86009 0.611206 9.31755 0.611206C9.775 0.611206 10.1457 0.982252 10.1457 1.44012Z",
    fill: "#17A7E0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5664 16.4204C27.5664 16.8783 27.1957 17.2493 26.7382 17.2493C26.2807 17.2493 25.9097 16.8783 25.9097 16.4204C25.9097 15.9625 26.2807 15.5915 26.7382 15.5915C27.1957 15.5915 27.5664 15.9625 27.5664 16.4204Z",
    fill: "#17A7E0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5664 12.6255C27.5664 13.0833 27.1957 13.4544 26.7382 13.4544C26.2807 13.4544 25.9097 13.0833 25.9097 12.6255C25.9097 12.1676 26.2807 11.7966 26.7382 11.7966C27.1957 11.7966 27.5664 12.1676 27.5664 12.6255Z",
    fill: "#17A7E0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6047 8.90435C27.6047 9.36221 27.234 9.73326 26.7765 9.73326C26.3191 9.73326 25.948 9.36221 25.948 8.90435C25.948 8.44649 26.3191 8.07544 26.7765 8.07544C27.234 8.07544 27.6047 8.44649 27.6047 8.90435Z",
    fill: "#17A7E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_8233",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 2,
    height: 3
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.242432 15.5915H1.89903V17.2493H0.242432V15.5915Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_8233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89902 16.4204C1.89902 16.8783 1.5283 17.2493 1.07084 17.2493C0.613386 17.2493 0.24231 16.8783 0.24231 16.4204C0.24231 15.9625 0.613386 15.5915 1.07084 15.5915C1.5283 15.5915 1.89902 15.9625 1.89902 16.4204Z",
    fill: "#17A7E0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_8233",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 19,
    width: 2,
    height: 2
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.242432 19.3372H1.89903V20.995H0.242432V19.3372Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_8233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89902 20.1661C1.89902 20.6239 1.5283 20.995 1.07084 20.995C0.613386 20.995 0.24231 20.6239 0.24231 20.1661C0.24231 19.7082 0.613386 19.3372 1.07084 19.3372C1.5283 19.3372 1.89902 19.7082 1.89902 20.1661Z",
    fill: "#17A7E0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_8233",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 2,
    height: 3
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.242432 11.7966H1.89903V13.4544H0.242432V11.7966Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_8233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89902 12.6255C1.89902 13.0833 1.5283 13.4544 1.07084 13.4544C0.613386 13.4544 0.24231 13.0833 0.24231 12.6255C0.24231 12.1676 0.613386 11.7966 1.07084 11.7966C1.5283 11.7966 1.89902 12.1676 1.89902 12.6255Z",
    fill: "#17A7E0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_8233",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 2,
    height: 2
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.242432 8.0755H1.89903V9.73332H0.242432V8.0755Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_8233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89902 8.90441C1.89902 9.36227 1.5283 9.73332 1.07084 9.73332C0.613386 9.73332 0.24231 9.36227 0.24231 8.90441C0.24231 8.44655 0.613386 8.0755 1.07084 8.0755C1.5283 8.0755 1.89902 8.44655 1.89902 8.90441Z",
    fill: "#17A7E0"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79745 4.99547C5.79745 5.45334 5.42674 5.82438 4.96928 5.82438C4.51182 5.82438 4.14075 5.45334 4.14075 4.99547C4.14075 4.53761 4.51182 4.16656 4.96928 4.16656C5.42674 4.16656 5.79745 4.53761 5.79745 4.99547Z",
    fill: "#17A7E0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79745 23.978C5.79745 24.4359 5.42674 24.8069 4.96928 24.8069C4.51182 24.8069 4.14075 24.4359 4.14075 23.978C4.14075 23.5202 4.51182 23.1491 4.96928 23.1491C5.42674 23.1491 5.79745 23.5202 5.79745 23.978Z",
    fill: "#17A7E0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79745 27.8817C5.79745 28.3396 5.42674 28.7106 4.96928 28.7106C4.51182 28.7106 4.14075 28.3396 4.14075 27.8817C4.14075 27.4238 4.51182 27.0528 4.96928 27.0528C5.42674 27.0528 5.79745 27.4238 5.79745 27.8817Z",
    fill: "#17A7E0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1457 31.6528C10.1457 32.1107 9.775 32.4817 9.31755 32.4817C8.86009 32.4817 8.48901 32.1107 8.48901 31.6528C8.48901 31.195 8.86009 30.8239 9.31755 30.8239C9.775 30.8239 10.1457 31.195 10.1457 31.6528Z",
    fill: "#17A7E0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4781 31.6144C19.4781 32.0722 19.1074 32.4433 18.6499 32.4433C18.1925 32.4433 17.8214 32.0722 17.8214 31.6144C17.8214 31.1565 18.1925 30.7855 18.6499 30.7855C19.1074 30.7855 19.4781 31.1565 19.4781 31.6144Z",
    fill: "#17A7E0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7663 35.377C14.7663 35.8349 14.3956 36.2059 13.9382 36.2059C13.4807 36.2059 13.1096 35.8349 13.1096 35.377C13.1096 34.9191 13.4807 34.5481 13.9382 34.5481C14.3956 34.5481 14.7663 34.9191 14.7663 35.377Z",
    fill: "#17A7E0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56635 8.90435C6.56635 9.78729 5.85137 10.5029 4.96921 10.5029C4.08705 10.5029 3.37207 9.78729 3.37207 8.90435C3.37207 8.0214 4.08705 7.30579 4.96921 7.30579C5.85137 7.30579 6.56635 8.0214 6.56635 8.90435Z",
    fill: "#17A7E0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56635 12.6255C6.56635 13.5084 5.85137 14.224 4.96921 14.224C4.08705 14.224 3.37207 13.5084 3.37207 12.6255C3.37207 11.7425 4.08705 11.0269 4.96921 11.0269C5.85137 11.0269 6.56635 11.7425 6.56635 12.6255Z",
    fill: "#17A7E0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56635 20.263C6.56635 21.1459 5.85137 21.8615 4.96921 21.8615C4.08705 21.8615 3.37207 21.1459 3.37207 20.263C3.37207 19.38 4.08705 18.6644 4.96921 18.6644C5.85137 18.6644 6.56635 19.38 6.56635 20.263Z",
    fill: "#17A7E0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50354 16.4204C6.50354 17.2688 5.81664 17.9563 4.96921 17.9563C4.1216 17.9563 3.43469 17.2688 3.43469 16.4204C3.43469 15.5722 4.1216 14.8847 4.96921 14.8847C5.81664 14.8847 6.50354 15.5722 6.50354 16.4204Z",
    fill: "#17A7E0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50354 20.2629C6.50354 21.1111 5.81664 21.7986 4.96921 21.7986C4.1216 21.7986 3.43469 21.1111 3.43469 20.2629C3.43469 19.4146 4.1216 18.7271 4.96921 18.7271C5.81664 18.7271 6.50354 19.4146 6.50354 20.2629Z",
    fill: "#17A7E0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8518 5.03386C10.8518 5.88205 10.1649 6.56956 9.31747 6.56956C8.46986 6.56956 7.78296 5.88205 7.78296 5.03386C7.78296 4.1855 8.46986 3.49799 9.31747 3.49799C10.1649 3.49799 10.8518 4.1855 10.8518 5.03386Z",
    fill: "#17A7E0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9146 8.9428C10.9146 9.82574 10.1996 10.5414 9.31748 10.5414C8.43532 10.5414 7.72034 9.82574 7.72034 8.9428C7.72034 8.05985 8.43532 7.34424 9.31748 7.34424C10.1996 7.34424 10.9146 8.05985 10.9146 8.9428Z",
    fill: "#17A7E0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9146 12.6639C10.9146 13.5468 10.1996 14.2624 9.31748 14.2624C8.43532 14.2624 7.72034 13.5468 7.72034 12.6639C7.72034 11.7809 8.43532 11.0653 9.31748 11.0653C10.1996 11.0653 10.9146 11.7809 10.9146 12.6639Z",
    fill: "#17A7E0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9146 16.4587C10.9146 17.3417 10.1996 18.0573 9.31748 18.0573C8.43532 18.0573 7.72034 17.3417 7.72034 16.4587C7.72034 15.5758 8.43532 14.8602 9.31748 14.8602C10.1996 14.8602 10.9146 15.5758 10.9146 16.4587Z",
    fill: "#17A7E0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9146 20.2516C10.9146 21.1346 10.1996 21.8502 9.31748 21.8502C8.43532 21.8502 7.72034 21.1346 7.72034 20.2516C7.72034 19.3687 8.43532 18.6531 9.31748 18.6531C10.1996 18.6531 10.9146 19.3687 10.9146 20.2516Z",
    fill: "#17A7E0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9146 24.061C10.9146 24.944 10.1996 25.6596 9.31748 25.6596C8.43532 25.6596 7.72034 24.944 7.72034 24.061C7.72034 23.1781 8.43532 22.4625 9.31748 22.4625C10.1996 22.4625 10.9146 23.1781 10.9146 24.061Z",
    fill: "#17A7E0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8518 27.8704C10.8518 28.7187 10.1649 29.4062 9.31747 29.4062C8.46986 29.4062 7.78296 28.7187 7.78296 27.8704C7.78296 27.0222 8.46986 26.3347 9.31747 26.3347C10.1649 26.3347 10.8518 27.0222 10.8518 27.8704Z",
    fill: "#17A7E0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9146 16.4587C10.9146 17.3417 10.1996 18.0573 9.31748 18.0573C8.43532 18.0573 7.72034 17.3417 7.72034 16.4587C7.72034 15.5758 8.43532 14.8602 9.31748 14.8602C10.1996 14.8602 10.9146 15.5758 10.9146 16.4587Z",
    fill: "#17A7E0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9146 20.2516C10.9146 21.1346 10.1996 21.8502 9.31748 21.8502C8.43532 21.8502 7.72034 21.1346 7.72034 20.2516C7.72034 19.3687 8.43532 18.6531 9.31748 18.6531C10.1996 18.6531 10.9146 19.3687 10.9146 20.2516Z",
    fill: "#17A7E0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9146 24.061C10.9146 24.944 10.1996 25.6596 9.31748 25.6596C8.43532 25.6596 7.72034 24.944 7.72034 24.061C7.72034 23.1781 8.43532 22.4625 9.31748 22.4625C10.1996 22.4625 10.9146 23.1781 10.9146 24.061Z",
    fill: "#17A7E0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4341 31.6144C15.4341 32.4627 14.7472 33.1502 13.8996 33.1502C13.052 33.1502 12.3651 32.4627 12.3651 31.6144C12.3651 30.7662 13.052 30.0785 13.8996 30.0785C14.7472 30.0785 15.4341 30.7662 15.4341 31.6144Z",
    fill: "#17A7E0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5572 35.9566H75.5263V28.8665C75.5263 27.5016 74.461 26.391 73.151 26.391C71.8415 26.391 70.7756 27.5016 70.7756 28.8665V35.9566H67.7452V28.8665C67.7452 25.8287 70.1704 23.3569 73.151 23.3569C76.1319 23.3569 78.5572 25.8287 78.5572 28.8665V35.9566Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7497 36.4741C37.7687 36.4741 35.3434 34.0024 35.3434 30.9647V23.5934H38.3743V30.9647C38.3743 32.33 39.4402 33.4406 40.7497 33.4406C42.0593 33.4406 43.125 32.33 43.125 30.9647V23.5934H46.1555V30.9647C46.1555 34.0024 43.7306 36.4741 40.7497 36.4741Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1892 35.9206H48.1583V27.1466C48.1583 25.1775 49.7535 23.5809 51.7213 23.5809H54.5771V26.6143H52.2596C51.6684 26.6143 51.1892 27.0942 51.1892 27.6859V35.9206Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.608 36.339C59.13 36.339 57.4224 36.05 56.3547 35.2134C55.4768 34.5248 55.0127 33.543 55.0127 32.3738C55.0127 30.7513 55.7991 29.8152 56.4597 29.3161C58.149 28.0385 61.0293 28.2676 62.8033 28.58V27.4031C62.8033 26.9713 62.4533 26.621 62.0214 26.621H56.8202V23.5874H62.1904C64.2025 23.5874 65.8338 25.2202 65.8338 27.2341V34.9646C65.8338 35.257 65.6346 35.512 65.3506 35.5821L64.6817 35.7473C64.1582 35.8764 62.4416 36.339 60.608 36.339ZM58.0432 32.1099C58.0432 33.8029 60.4999 34.0196 62.8033 33.4733V31.0872C61.9266 30.6987 58.0432 30.1684 58.0432 32.1099Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_8233",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 79,
    height: 42
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.242432 41.6681H78.5572V0.496094H0.242432V41.6681Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_8233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5939 35.9206H24.6248V23.5934H21.5939V35.9206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8262 26.6441H33.6649V23.6106H30.8265C30.4762 23.6106 30.138 23.6601 29.8141 23.7446V19.0249H26.7832V31.3521H26.7918V32.4343C26.7918 34.3806 28.3683 35.9588 30.3131 35.9588H33.6182V32.9249H30.5787C30.161 32.9249 29.8227 32.5863 29.8227 32.168V27.6487C29.8227 27.0939 30.2719 26.6441 30.8262 26.6441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.259 41.6373H21.8912V39.7007H21.2291V39.3848H22.9209V39.7007H22.259V41.6373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5388 41.6373H23.2657V39.3848H24.5388V39.6962H23.6338V40.3093H24.4819V40.6173H23.6338V41.3247H24.5388V41.6373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9827 39.6683C25.7712 39.6683 25.6049 39.7433 25.484 39.8933C25.3629 40.0432 25.3022 40.2501 25.3022 40.5142C25.3022 40.7905 25.3605 40.9996 25.477 41.1414C25.5934 41.2829 25.762 41.3537 25.9827 41.3537C26.078 41.3537 26.1704 41.3444 26.2598 41.3253C26.3491 41.3064 26.4419 41.282 26.5384 41.2521V41.5681C26.3618 41.6347 26.1617 41.6682 25.938 41.6682C25.6085 41.6682 25.3557 41.5682 25.1791 41.3685C25.0026 41.1687 24.9144 40.8829 24.9144 40.5111C24.9144 40.277 24.9573 40.072 25.0429 39.8964C25.1286 39.7208 25.2526 39.5862 25.4147 39.4925C25.5769 39.3992 25.7673 39.3524 25.9857 39.3524C26.2155 39.3524 26.4281 39.4009 26.6231 39.4974L26.4907 39.804C26.4148 39.768 26.3345 39.7364 26.2497 39.7092C26.1651 39.6819 26.0761 39.6683 25.9827 39.6683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8981 41.6373H28.4472L27.3404 39.8424H27.328L27.3357 39.9426C27.3501 40.1335 27.3571 40.3082 27.3571 40.4664V41.6373H27.0233V39.3848H27.4696L28.5733 41.1705H28.5827C28.5805 41.1469 28.5764 41.061 28.5702 40.9125C28.5641 40.7639 28.5611 40.6483 28.5611 40.5651V39.3848H28.8981V41.6373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7722 40.5081C29.7722 40.7853 29.8282 40.9957 29.9401 41.1389C30.0519 41.2822 30.2176 41.3537 30.4372 41.3537C30.6558 41.3537 30.8209 41.283 30.9321 41.1414C31.0435 40.9996 31.0993 40.7885 31.0993 40.5081C31.0993 40.2318 31.044 40.0223 30.9337 39.8795C30.8234 39.7366 30.6589 39.6651 30.4403 39.6651C30.2196 39.6651 30.0532 39.7366 29.9409 39.8795C29.8284 40.0223 29.7722 40.2318 29.7722 40.5081ZM31.4902 40.5081C31.4902 40.8746 31.3986 41.1597 31.2156 41.3631C31.0322 41.5665 30.7729 41.668 30.4373 41.668C30.0977 41.668 29.8368 41.5672 29.6546 41.3654C29.4723 41.1637 29.3815 40.8768 29.3815 40.5048C29.3815 40.1331 29.4729 39.8476 29.6561 39.6484C29.8393 39.449 30.1008 39.3494 30.4404 39.3494C30.7749 39.3494 31.0335 39.4506 31.2162 39.6529C31.399 39.8553 31.4902 40.1403 31.4902 40.5081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9738 41.6373V39.3848H32.3416V41.3214H33.2945V41.6373H31.9738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8995 40.5081C33.8995 40.7853 33.9554 40.9957 34.0674 41.1389C34.1791 41.2822 34.3449 41.3537 34.5644 41.3537C34.7831 41.3537 34.9481 41.283 35.0593 41.1414C35.1707 40.9996 35.2265 40.7885 35.2265 40.5081C35.2265 40.2318 35.1712 40.0223 35.0609 39.8795C34.9506 39.7366 34.7861 39.6651 34.5675 39.6651C34.3468 39.6651 34.1804 39.7366 34.0681 39.8795C33.9556 40.0223 33.8995 40.2318 33.8995 40.5081ZM35.6173 40.5081C35.6173 40.8746 35.5257 41.1597 35.3427 41.3631C35.1593 41.5665 34.9 41.668 34.5644 41.668C34.2248 41.668 33.9638 41.5672 33.7817 41.3654C33.5994 41.1637 33.5085 40.8768 33.5085 40.5048C33.5085 40.1331 33.6 39.8476 33.7832 39.6484C33.9664 39.449 34.2278 39.3494 34.5674 39.3494C34.902 39.3494 35.1606 39.4506 35.3432 39.6529C35.5261 39.8553 35.6173 40.1403 35.6173 40.5081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0212 40.4155H37.8494V41.5463C37.7139 41.5905 37.5838 41.6218 37.4592 41.6405C37.3345 41.6589 37.1997 41.6681 37.055 41.6681C36.7144 41.6681 36.4516 41.5672 36.267 41.3653C36.0822 41.1636 35.9899 40.8788 35.9899 40.511C35.9899 40.1486 36.0941 39.8647 36.3023 39.6599C36.5107 39.455 36.7975 39.3525 37.1628 39.3525C37.3979 39.3525 37.6205 39.3977 37.8309 39.4881L37.7016 39.7947C37.519 39.7104 37.3361 39.6684 37.1535 39.6684C36.9134 39.6684 36.7236 39.7439 36.5841 39.8946C36.4444 40.0458 36.3746 40.2524 36.3746 40.5142C36.3746 40.7895 36.4374 40.9986 36.5632 41.142C36.689 41.2853 36.8699 41.357 37.1058 41.357C37.2249 41.357 37.3522 41.3421 37.4877 41.3124V40.7315H37.0212V40.4155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3896 41.6373H38.7575V39.3848H38.3896V41.6373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4261 40.6944L40.2152 40.0813C40.1999 40.0402 40.1785 39.9755 40.1515 39.8873C40.1242 39.7988 40.1054 39.7342 40.0952 39.6929C40.0675 39.8194 40.027 39.9575 39.9735 40.1074L39.7704 40.6944H40.4261ZM40.7479 41.6373L40.5232 41.0119H39.6628L39.4427 41.6373H39.0547L39.8967 39.3757H40.2969L41.139 41.6373H40.7479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6229 40.4849H42.8184C43.0073 40.4849 43.1457 40.4519 43.2341 40.3863C43.3222 40.3206 43.3665 40.2179 43.3665 40.0782C43.3665 39.9487 43.3269 39.8521 43.2479 39.7885C43.1687 39.7248 43.0458 39.6931 42.8785 39.6931H42.6229V40.4849ZM43.745 40.0659C43.745 40.301 43.6681 40.4813 43.5141 40.6066C43.3604 40.732 43.1412 40.7947 42.8568 40.7947H42.6229V41.6373H42.2549V39.3849H42.9031C43.1842 39.3849 43.3949 39.4423 43.5349 39.5574C43.6751 39.6724 43.745 39.842 43.745 40.0659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1945 41.6373H44.5625V39.3848H44.1945V41.6373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1564 41.6373V39.3848H45.5244V41.3214H46.4773V41.6373H45.1564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0824 40.5081C47.0824 40.7853 47.1383 40.9957 47.2501 41.1389C47.362 41.2822 47.5278 41.3537 47.7473 41.3537C47.9658 41.3537 48.1308 41.283 48.2422 41.1414C48.3534 40.9996 48.4092 40.7885 48.4092 40.5081C48.4092 40.2318 48.354 40.0223 48.2436 39.8795C48.1335 39.7366 47.969 39.6651 47.7504 39.6651C47.5297 39.6651 47.3633 39.7366 47.251 39.8795C47.1385 40.0223 47.0824 40.2318 47.0824 40.5081ZM48.8002 40.5081C48.8002 40.8746 48.7086 41.1597 48.5254 41.3631C48.3422 41.5665 48.0829 41.668 47.7473 41.668C47.4077 41.668 47.1466 41.5672 46.9646 41.3654C46.7823 41.1637 46.6913 40.8768 46.6913 40.5048C46.6913 40.1331 46.7829 39.8476 46.9661 39.6484C47.1493 39.449 47.4106 39.3494 47.7503 39.3494C48.0849 39.3494 48.3435 39.4506 48.5261 39.6529C48.7088 39.8553 48.8002 40.1403 48.8002 40.5081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.967 41.6373H49.599V39.7007H48.9371V39.3848H50.6289V39.7007H49.967V41.6373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8279 40.6944L51.617 40.0813C51.6017 40.0402 51.5803 39.9755 51.5533 39.8873C51.5259 39.7988 51.5072 39.7342 51.497 39.6929C51.4693 39.8194 51.4288 39.9575 51.3753 40.1074L51.1721 40.6944H51.8279ZM52.1497 41.6373L51.9249 41.0119H51.0645L50.8442 41.6373H50.4564L51.2985 39.3757H51.6987L52.5407 41.6373H52.1497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2802 40.5019C54.2802 39.9626 54.0283 39.693 53.5244 39.693H53.2057V41.3276H53.4673C54.0092 41.3276 54.2802 41.0525 54.2802 40.5019ZM54.668 40.4895C54.668 40.8613 54.5649 41.1455 54.3587 41.3424C54.1524 41.5391 53.8553 41.6374 53.4673 41.6374H52.8376V39.3848H53.5337C53.8917 39.3848 54.1704 39.4814 54.3695 39.6745C54.5687 39.8677 54.668 40.1392 54.668 40.4895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1628 40.6944L55.9518 40.0813C55.9365 40.0402 55.9151 39.9755 55.8881 39.8873C55.8608 39.7988 55.8421 39.7342 55.8318 39.6929C55.8041 39.8194 55.7636 39.9575 55.7102 40.1074L55.507 40.6944H56.1628ZM56.4845 41.6373L56.2597 41.0119H55.3993L55.1791 41.6373H54.7913L55.6333 39.3757H56.0335L56.8756 41.6373H56.4845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3594 40.4849H58.5548C58.7438 40.4849 58.8822 40.4519 58.9705 40.3863C59.0587 40.3206 59.103 40.2179 59.103 40.0782C59.103 39.9487 59.0634 39.8521 58.9844 39.7885C58.9052 39.7248 58.7823 39.6931 58.6149 39.6931H58.3594V40.4849ZM59.4814 40.0659C59.4814 40.301 59.4046 40.4813 59.2505 40.6066C59.0968 40.732 58.8776 40.7947 58.5933 40.7947H58.3594V41.6373H57.9913V39.3849H58.6395C58.9206 39.3849 59.1314 39.4423 59.2714 39.5574C59.4116 39.6724 59.4814 39.842 59.4814 40.0659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2112 40.5081C60.2112 40.7853 60.2672 40.9957 60.3789 41.1389C60.4909 41.2822 60.6566 41.3537 60.8762 41.3537C61.0946 41.3537 61.2596 41.283 61.371 41.1414C61.4823 40.9996 61.538 40.7885 61.538 40.5081C61.538 40.2318 61.4828 40.0223 61.3725 39.8795C61.2623 39.7366 61.0979 39.6651 60.8792 39.6651C60.6586 39.6651 60.4921 39.7366 60.3798 39.8795C60.2674 40.0223 60.2112 40.2318 60.2112 40.5081ZM61.9291 40.5081C61.9291 40.8746 61.8375 41.1597 61.6543 41.3631C61.4711 41.5665 61.2118 41.668 60.8762 41.668C60.5366 41.668 60.2755 41.5672 60.0935 41.3654C59.9112 41.1637 59.8202 40.8768 59.8202 40.5048C59.8202 40.1331 59.9118 39.8476 60.095 39.6484C60.2782 39.449 60.5395 39.3494 60.8793 39.3494C61.2138 39.3494 61.4724 39.4506 61.6551 39.6529C61.8377 39.8553 61.9291 40.1403 61.9291 40.5081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7804 40.4324H63.0359C63.2072 40.4324 63.3316 40.4005 63.4084 40.3369C63.4854 40.2732 63.5239 40.1788 63.5239 40.0534C63.5239 39.9261 63.4822 39.8347 63.3991 39.7793C63.3161 39.7236 63.1908 39.6961 63.0237 39.6961H62.7804V40.4324ZM62.7804 40.7375V41.6372H62.4124V39.3848H63.0482C63.3386 39.3848 63.5537 39.4392 63.6931 39.5482C63.8328 39.657 63.9024 39.8213 63.9024 40.0412C63.9024 40.3216 63.7568 40.5214 63.4655 40.6404L64.1011 41.6372H63.6825L63.1437 40.7375H62.7804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6143 40.4849H65.8098C65.9987 40.4849 66.1371 40.4519 66.2255 40.3863C66.3137 40.3206 66.3579 40.2179 66.3579 40.0782C66.3579 39.9487 66.3183 39.8521 66.2393 39.7885C66.1602 39.7248 66.0372 39.6931 65.8699 39.6931H65.6143V40.4849ZM66.7364 40.0659C66.7364 40.301 66.6596 40.4813 66.5055 40.6066C66.3518 40.732 66.1326 40.7947 65.8483 40.7947H65.6144V41.6373H65.2463V39.3849H65.8946C66.1756 39.3849 66.3864 39.4423 66.5264 39.5574C66.6666 39.6724 66.7364 39.842 66.7364 40.0659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4588 41.6373H67.1858V39.3848H68.4588V39.6962H67.5538V40.3093H68.402V40.6173H67.5538V41.3247H68.4588V41.6373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.243 41.0257C70.243 41.2258 70.1708 41.3831 70.026 41.4971C69.8813 41.6111 69.6817 41.668 69.4272 41.668C69.1728 41.668 68.9644 41.6286 68.8022 41.5495V41.2013C68.9048 41.2496 69.0139 41.2876 69.1294 41.3152C69.2448 41.3431 69.3524 41.357 69.4519 41.357C69.5975 41.357 69.7051 41.3292 69.7744 41.2738C69.8435 41.2183 69.8782 41.1437 69.8782 41.0504C69.8782 40.9661 69.8464 40.8946 69.7827 40.8361C69.7191 40.7775 69.5878 40.7082 69.3887 40.6282C69.1834 40.545 69.0389 40.4501 68.9547 40.3431C68.8705 40.2363 68.8285 40.1078 68.8285 39.958C68.8285 39.7699 68.8951 39.6221 69.0285 39.5142C69.162 39.4065 69.341 39.3524 69.5656 39.3524C69.7814 39.3524 69.9957 39.3998 70.2093 39.4942L70.0922 39.7946C69.8921 39.7103 69.7136 39.6683 69.5566 39.6683C69.4373 39.6683 69.3472 39.6941 69.2856 39.7462C69.2241 39.798 69.1933 39.8665 69.1933 39.9519C69.1933 40.0102 69.2055 40.0605 69.2302 40.1021C69.2548 40.1437 69.2953 40.1828 69.3518 40.2199C69.4082 40.2568 69.5098 40.3056 69.6565 40.3663C69.8217 40.4351 69.9428 40.4992 70.0199 40.5589C70.0969 40.6183 70.1532 40.6857 70.1892 40.7606C70.225 40.8355 70.243 40.9241 70.243 41.0257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9763 41.0257C71.9763 41.2258 71.9041 41.3831 71.7592 41.4971C71.6146 41.6111 71.415 41.668 71.1605 41.668C70.9061 41.668 70.6977 41.6286 70.5355 41.5495V41.2013C70.6381 41.2496 70.7472 41.2876 70.8627 41.3152C70.978 41.3431 71.0857 41.357 71.1852 41.357C71.3308 41.357 71.4384 41.3292 71.5077 41.2738C71.5768 41.2183 71.6115 41.1437 71.6115 41.0504C71.6115 40.9661 71.5796 40.8946 71.5159 40.8361C71.4524 40.7775 71.321 40.7082 71.122 40.6282C70.9167 40.545 70.7722 40.4501 70.6879 40.3431C70.6037 40.2363 70.5618 40.1078 70.5618 39.958C70.5618 39.7699 70.6284 39.6221 70.7617 39.5142C70.8953 39.4065 71.0743 39.3524 71.2989 39.3524C71.5147 39.3524 71.729 39.3998 71.9426 39.4942L71.8255 39.7946C71.6254 39.7103 71.4468 39.6683 71.2899 39.6683C71.1706 39.6683 71.0804 39.6941 71.0189 39.7462C70.9573 39.798 70.9266 39.8665 70.9266 39.9519C70.9266 40.0102 70.9388 40.0605 70.9635 40.1021C70.9881 40.1437 71.0286 40.1828 71.0851 40.2199C71.1414 40.2568 71.2431 40.3056 71.3898 40.3663C71.555 40.4351 71.6761 40.4992 71.7531 40.5589C71.8302 40.6183 71.8865 40.6857 71.9225 40.7606C71.9583 40.8355 71.9763 40.9241 71.9763 41.0257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.692 40.5081C72.692 40.7853 72.748 40.9957 72.8597 41.1389C72.9717 41.2822 73.1374 41.3537 73.357 41.3537C73.5754 41.3537 73.7405 41.283 73.8519 41.1414C73.9631 40.9996 74.0189 40.7885 74.0189 40.5081C74.0189 40.2318 73.9636 40.0223 73.8533 39.8795C73.7432 39.7366 73.5787 39.6651 73.36 39.6651C73.1394 39.6651 72.9729 39.7366 72.8606 39.8795C72.7482 40.0223 72.692 40.2318 72.692 40.5081ZM74.41 40.5081C74.41 40.8746 74.3184 41.1597 74.1352 41.3631C73.952 41.5665 73.6926 41.668 73.357 41.668C73.0174 41.668 72.7563 41.5672 72.5744 41.3654C72.3921 41.1637 72.301 40.8768 72.301 40.5048C72.301 40.1331 72.3926 39.8476 72.5758 39.6484C72.759 39.449 73.0203 39.3494 73.3601 39.3494C73.6946 39.3494 73.9532 39.4506 74.1359 39.6529C74.3185 39.8553 74.41 40.1403 74.41 40.5081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9047 40.6944L75.6938 40.0813C75.6785 40.0402 75.6571 39.9755 75.6301 39.8873C75.6027 39.7988 75.584 39.7342 75.5737 39.6929C75.546 39.8194 75.5055 39.9575 75.4521 40.1074L75.2489 40.6944H75.9047ZM76.2264 41.6373L76.0017 41.0119H75.1413L74.921 41.6373H74.5332L75.3752 39.3757H75.7755L76.6175 41.6373H76.2264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.212 41.0257C78.212 41.2258 78.1398 41.3831 77.995 41.4971C77.8503 41.6111 77.6507 41.668 77.3962 41.668C77.1418 41.668 76.9334 41.6286 76.7712 41.5495V41.2013C76.8738 41.2496 76.9829 41.2876 77.0984 41.3152C77.2138 41.3431 77.3214 41.357 77.4209 41.357C77.5665 41.357 77.6741 41.3292 77.7434 41.2738C77.8125 41.2183 77.8472 41.1437 77.8472 41.0504C77.8472 40.9661 77.8154 40.8946 77.7517 40.8361C77.6881 40.7775 77.5568 40.7082 77.3577 40.6282C77.1524 40.545 77.0079 40.4501 76.9237 40.3431C76.8394 40.2363 76.7975 40.1078 76.7975 39.958C76.7975 39.7699 76.8641 39.6221 76.9974 39.5142C77.131 39.4065 77.31 39.3524 77.5346 39.3524C77.7504 39.3524 77.9647 39.3998 78.1783 39.4942L78.0612 39.7946C77.8611 39.7103 77.6826 39.6683 77.5256 39.6683C77.4063 39.6683 77.3162 39.6941 77.2546 39.7462C77.1931 39.798 77.1623 39.8665 77.1623 39.9519C77.1623 40.0102 77.1745 40.0605 77.1992 40.1021C77.2238 40.1437 77.2643 40.1828 77.3208 40.2199C77.3772 40.2568 77.4788 40.3056 77.6255 40.3663C77.7907 40.4351 77.9118 40.4992 77.9888 40.5589C78.0659 40.6183 78.1222 40.6857 78.1582 40.7606C78.194 40.8355 78.212 40.9241 78.212 41.0257Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoIturan);
export default __webpack_public_path__ + "static/media/ic-logo-ituran.bc67f44f5c0f22d14608d9b50a13a9b3.svg";
export { ForwardRef as ReactComponent };